var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6839 7.90597L5.66422 5.92566C6.06819 5.5217 6.20796 4.92482 6.04458 4.37739C5.91683 3.94933 5.77289 3.43473 5.67721 2.99469C5.58872 2.5877 5.23159 2.25 4.81509 2.25H3.6839C2.8509 2.25 2.16684 2.92788 2.25821 3.75585C2.95282 10.0497 7.9503 15.0472 14.2442 15.7418C15.0722 15.8332 15.75 15.1491 15.75 14.3161V13.1849C15.75 12.7685 15.4109 12.4268 15.0011 12.3522C14.5491 12.27 14.0708 12.1353 13.6707 12.0077C13.0958 11.8244 12.4568 11.9533 12.0302 12.3799L10.094 14.3161",
    stroke: "#62636C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.c2bc0009211740c270a6989d1b6a5103.svg";
export { ForwardRef as ReactComponent };